import { adminHttpClient } from '../commons/adminHttpClient'

export interface DefaultExpenseCategory {
  id: number
  name: string
}

const getDefaultExpenseCategories = (productId: number): Promise<DefaultExpenseCategory[]> =>
  adminHttpClient.get('Expenses/DefaultExpenseCategories', { productId })

export default getDefaultExpenseCategories
